export default __webpack_public_path__ + "static/header-aec003f959176e721f220e62f8408718.png";